import { BIndexThresholdType, QuestionStatus } from '@report/graphql';
import {
  parseAsArrayOf,
  parseAsInteger,
  useQueryStates,
  parseAsStringEnum,
  parseAsString,
  parseAsStringLiteral,
} from 'nuqs';

import { MONTH_ORDER } from '../../constants';
import { type MonthAbbreviation } from '../../types';

export function useItemAnalysisYearlySearchParams() {
  const [
    {
      startMonth,
      endMonth,
      startYear,
      endYear,
      examCourse,
      questionStatus,
      minExaminees,
      knowledgeGroupSelection,
      knowledgeGroupCustomThreshold,
      nonKnowledgeGroupSelection,
      nonKnowledgeGroupCustomThreshold,
      page,
      pageSize,
    },
    setQueryParams,
  ] = useQueryStates({
    startMonth: parseAsStringLiteral<MonthAbbreviation>(MONTH_ORDER),
    startYear: parseAsInteger.withDefault(0),
    endMonth: parseAsStringLiteral<MonthAbbreviation>(MONTH_ORDER),
    endYear: parseAsInteger.withDefault(0),
    examCourse: parseAsString.withDefault(''),
    questionStatus: parseAsArrayOf(parseAsStringEnum(Object.values(QuestionStatus))).withDefault(
      [],
    ),
    minExaminees: parseAsInteger,
    knowledgeGroupSelection: parseAsStringEnum(Object.values(BIndexThresholdType)).withDefault(
      BIndexThresholdType.UseExamResult,
    ),
    knowledgeGroupCustomThreshold: parseAsInteger,
    nonKnowledgeGroupSelection: parseAsStringEnum(Object.values(BIndexThresholdType)).withDefault(
      BIndexThresholdType.UseExamResult,
    ),
    nonKnowledgeGroupCustomThreshold: parseAsInteger,
    page: parseAsInteger.withDefault(0),
    pageSize: parseAsInteger.withDefault(50),
  });

  const changeFilterParams = (params: {
    startMonth: MonthAbbreviation | null;
    startYear: number | null;
    endMonth: MonthAbbreviation | null;
    endYear: number | null;
    examCourse: string;
    questionStatus: QuestionStatus[];
    minExaminees: number | null;
    knowledgeGroupSelection: BIndexThresholdType;
    knowledgeGroupCustomThreshold: number | null;
    nonKnowledgeGroupSelection: BIndexThresholdType;
    nonKnowledgeGroupCustomThreshold: number | null;
    page: number;
    pageSize: number;
  }) => {
    setQueryParams(params);
  };

  const changePage = (page: number) => {
    setQueryParams({ page });
  };
  const changePageSize = (pageSize: number) => {
    setQueryParams({ page: 0, pageSize });
  };

  return [
    {
      startMonth,
      endMonth,
      startYear,
      endYear,
      examCourse,
      questionStatus,
      minExaminees,
      knowledgeGroupSelection,
      knowledgeGroupCustomThreshold,
      nonKnowledgeGroupSelection,
      nonKnowledgeGroupCustomThreshold,
      page,
      pageSize,
    },
    {
      changeFilterParams,
      changePage,
      changePageSize,
    },
  ] as const;
}
